// extracted by css-extract-rspack-plugin
export default {"row":"MergeStatusSkeleton-module__row__ULN1L","rowText":"MergeStatusSkeleton-module__rowText__OXZ_h"};